import React, { useState, useEffect, useRef } from "react";

/** Shared show/hide column picker for Indirect P&L and Fringe P&L multi-table views. */
export default function IndirectPlColumnPicker({
  classes,
  months,
  hiddenCols,
  activeMonths,
  onToggleCol,
  onShowAllCols,
}) {
  const [colPickerOpen, setColPickerOpen] = useState(false);
  const colPickerRef = useRef(null);
  const hiddenCount = hiddenCols.size;

  useEffect(() => {
    if (!colPickerOpen) return;
    const handler = (e) => {
      if (colPickerRef.current && !colPickerRef.current.contains(e.target))
        setColPickerOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [colPickerOpen]);

  return (
    <div className={classes.colPickerWrap} ref={colPickerRef}>
      <button
        type="button"
        className={`${classes.colsBtn} ${colPickerOpen ? classes.colsBtnActive : ""}`}
        onClick={() => setColPickerOpen((p) => !p)}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="3" width="7" height="18" /><rect x="14" y="3" width="7" height="18" />
        </svg>
        Columns
        {hiddenCount > 0 && <span className={classes.hiddenBadge}>{hiddenCount} Hidden</span>}
      </button>
      {colPickerOpen && (
        <div className={classes.colPicker}>
          <div className={classes.colPickerHeader}>
            <span className={classes.colPickerTitle}>Show / Hide</span>
            {hiddenCount > 0 && (
              <button type="button" className={classes.colPickerReset} onClick={onShowAllCols}>
                Show All
              </button>
            )}
          </div>
          <div className={classes.colPickerSection}>Months</div>
          {/* A selected global month/quarter filter overrides this picker — the
              checkboxes just reflect that selection and can't be toggled while
              it's active, same as hiding Jan then selecting Jan globally must
              bring the Jan column back rather than keep it hidden. */}
          {months.map((m) => (
            <label
              key={m}
              className={classes.colPickerItem}
              style={!!activeMonths && !activeMonths.has(m) ? { opacity: 0.45 } : undefined}
            >
              <input
                type="checkbox"
                className={classes.colPickerCheck}
                checked={activeMonths ? activeMonths.has(m) : !hiddenCols.has(m)}
                disabled={!!activeMonths}
                onChange={() => onToggleCol(m)}
              />
              {m}
            </label>
          ))}
          <div className={classes.colPickerSection}>Other</div>
          <label className={classes.colPickerItem}>
            <input
              type="checkbox"
              className={classes.colPickerCheck}
              checked={!hiddenCols.has("_total")}
              onChange={() => onToggleCol("_total")}
            />
            Total
          </label>
        </div>
      )}
    </div>
  );
}
